<template>
  <base-box :class="`campaign-box ${getStatus()}`">
    <div>
      <p v-if="action" class="status">
        <span v-if="status == 'DISABLED'">EXPIRADA</span>
        <span v-else-if="status == 'PAUSED'">PAUSADA</span>
        <span v-else>ATIVA</span>
      </p>
      <div class="info">
        <i :class="icon" class="d-show"></i>
        <div>
          <p class="name">{{ name }}</p>
          <p class="desc">
            <slot></slot>
          </p>
          <div v-if="action" class="action-btns">
            <base-button
              v-if="status !== 'PAUSED'"
              @click="actions(1)"
              :text="'Pausar'"
              :design="`three ${getStatus()}`"
              class="mr_15"
            />
            <base-button
              v-if="status === 'PAUSED'"
              @click="actions(2)"
              :text="'Ativar'"
              :design="`three ${getStatus()}`"
              class="mr_15"
            />
            <base-button
              @click="actions(3)"
              :text="'Editar'"
              :design="`three ${getStatus()}`"
              class="mr_15"
            />
            <base-button
              @click="actions(4)"
              :text="'Resultados'"
              :design="`three ${getStatus()}`"
              class="mr_15"
            />
          </div>
        </div>
      </div>
    </div>
  </base-box>
</template>

<script>
import BaseButton from "@/components/Button";
import BaseBox from "@/components/Box";

export default {
  props: {
    status: { type: String, default: "SCHEDULED" },
    name: { type: String, required: true },
    icon: { type: String, required: true },
    id: {},
    action: { type: Boolean, default: true },
  },
  methods: {
    getStatus() {
      switch (this.status) {
        case "DISABLED":
          return "gray";
        case "PAUSED":
          return "orange";
        default:
          return "blue";
      }
    },
    actions(action) {
      this.$emit("action", { action: action, id: this.id });
    },
  },
  components: {
    BaseButton,
    BaseBox,
  },
};
</script>

<style scoped>
.campaign-box {
  margin-bottom: 30px;
  position: relative;
  padding: 40px;
  height: 210px;
  display: flex;
  align-items: center;
}

.campaign-box > div:first-child {
  opacity: 0.8;
}

.campaign-box .status {
  font-size: 1.1em;
  font-weight: 600;
  color: white;
  position: absolute;
  padding: 11px 24px;
  top: 0;
  right: 0;
  border-radius: 0 0 0 5px;
}

.campaign-box .info {
  display: flex;
  align-items: center;
}

.campaign-box .info i {
  font-size: 5em;
  margin-right: 40px;
  margin-bottom: 10px;
}

.campaign-box .info .name {
  font-size: 2em;
  font-weight: 900;
  margin-bottom: 20px;
}

.campaign-box .info .desc {
  font-size: 1.6em;
  font-weight: 300;
  color: #777;
  padding-right: 40px;
  margin-bottom: 10px;
}

.action-btns button {
  margin-top: 10px;
  margin-right: 15px;
}

/* Campanha ativa */
.campaign-box.blue .status {
  background-color: var(--default-hover);
}

.campaign-box.blue .info i,
.campaign-box.blue .info .name {
  color: var(--default);
}

/* Campanha pausada */
.campaign-box.orange .status {
  background-color: #ff9d11;
}

.campaign-box.orange .info i,
.campaign-box.orange .info .name {
  color: #ff9d11;
}

/* Campanha expirada */
.campaign-box.gray .status {
  background-color: #777;
}

.campaign-box.gray .info i,
.campaign-box.gray .info .name {
  color: #777;
}

/* RESPONSIVO */
@media (max-width: 991px) {
  .campaign-box {
    height: auto;
    padding: 50px 40px;
  }
}
</style>